const pages = [
  {
    name: 'Cookies',
    responsibleTeam: 'mpp'
  },
  {
    name: 'Error',
    responsibleTeam: 'mpp'
  },
  {
    name: 'Marketing',
    responsibleTeam: 'meg',
    experimentationFeatureKey: 'meg.grab-and-go',
    requireAuthentication: true,
    subpages: [
      { name: 'ChannelSelector', overrideTopBarConfig: true },
      { name: 'EmailTemplates', overrideTopBarConfig: true },
      { name: 'EmailHeader', overrideTopBarConfig: true },
      { name: 'Social', overrideTopBarConfig: true }
    ]
  },
  {
    name: 'PrivacyPolicy',
    responsibleTeam: 'mpp'
  },
  {
    name: 'Support',
    responsibleTeam: 'meg',
    requireAuthentication: true,
    experimentationFeatureKey: 'meg.merchant-support-center',
    subpages: [
      { name: 'Ticket', param: ':id', overrideTopBarConfig: true }
    ]
  },
  {
    name: 'TermsAndConditions',
    responsibleTeam: 'mpp'
  }
]

export default pages
